import { render, staticRenderFns } from "./EditStoreSidebar.vue?vue&type=template&id=c12a7e7e"
import script from "./EditStoreSidebar.vue?vue&type=script&lang=js"
export * from "./EditStoreSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports